import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ConfirmationPopup from "../../packages/ConfirmationPopup";
import { CustomModalButtons } from "../../constants/global.constants";
import { useUnsavedChanges } from "../../hooks/useUnsavedChanges";

import "./index.scss";

const UnsavedChangesDialog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    showDialog,
    setShowDialog,
    targetPathRef,
    pendingActionRef,
    allowActionRef,
  } = useUnsavedChanges();

  const handleClose = (action) => {
    setShowDialog(false);

    if (action === CustomModalButtons.CONFIRM) {
      allowActionRef.current = true;
      const navigatePath = targetPathRef.current;
      if (navigatePath) {
        navigate(navigatePath);
      } else {
        const actionHandler = pendingActionRef.current;
        actionHandler && actionHandler();
      }
    }
    targetPathRef.current = null;
    pendingActionRef.current = null;
    allowActionRef.current = false;
  };

  if (!showDialog) return null;

  return (
    <ConfirmationPopup
      header={t("unsavedChanges.title")}
      description={t("unsavedChanges.description")}
      confirmBtn={t("ValueStrings.okay")}
      cancelBtn={t("ValueStrings.cancel")}
      onClose={handleClose}
      customClassName="unsaved-changes-dialog"
      width="450px"
    />
  );
};

export default UnsavedChangesDialog;
